import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import styles from '../styles'

const ChatSidebarView = ({ children, classes }) => {
  return <section className={classes.chatSidebarWrapper}>{children}</section>
}
ChatSidebarView.propTypes = {
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatSidebarView)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatSidebar/component/ChatSidebarView.js